<template lang="pug">
#app.main(:class='loading ? "loading" : ""')
    header-component
    .page-content
        sidebar-component(v-if='isSidebarVisible')
            router-view.principal
        router-view(v-else).principal

    modal-component(
        v-if='modalRegerarTermo',
        title='Regerar Termos',
        @close='modalRegerarTermo = false'
        width='1024px'
    )
        ModalRegerarTermos(
            text='Para proteger sua segurança, é necessário confirmar sua identidade antes de prosseguir com a assinatura do termo de compromisso.',
            @cancelar='modalRegerarTermo = false'
        )

    footer-component
</template>

<script>
import BUS from '@/utils/bus.utils';
import FooterComponent from './components/FooterComponent.vue';
import HeaderComponent from './components/HeaderComponent.vue';
import SidebarComponent from './components/SidebarComponent.vue';
import { Perfil } from '@/utils/constants.utils.js';
import ModalRegerarTermos from '@/views/caixaEntrada/components/ModalRegerarTermos.vue';

export default {
    name: 'App',
    components: {
        FooterComponent,
        HeaderComponent,
        SidebarComponent,
        ModalRegerarTermos
    },
    data() {
        return {
            loading: false,
            modalRegerarTermo: false,
        };
    },
    computed: {
        isSidebarVisible() {
           const perfis_invisiveis = [Perfil.USUARIO_EXTERNO];
           return !perfis_invisiveis.includes(this.$eu()?.perfil)
        },

        isUsuarioExterno() {
            return this.$eu()?.perfil == Perfil.USUARIO_EXTERNO;
        }
    },
    methods: {
        checaCombinacaoTeclas(event) {
            if (event.ctrlKey && event.altKey && event.key === 'r') {
                this.modalRegerarTermo = true;
            }
        },
        loadScript(src) {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.async = true;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        checkComponentRegistration() {
            if (!window.customElements.get('mapa-geo-car-wc')) {
                console.error('O Web Component "mapa-geo-car-wc" não foi registrado corretamente.');
            }
        }
    },
    async mounted() {
        window.addEventListener('keydown', this.checaCombinacaoTeclas);

        try {
            let urlScript = '/static/mapa-geo-car-wc/mapa-geo-car-wc.min.js';
            if (process.env.NODE_ENV === 'development') {
                urlScript = 'http://10.153.18.103/static/mapa-geo-car-wc/mapa-geo-car-wc-dev.js';
            }

            await this.loadScript(urlScript);
            this.checkComponentRegistration();
        } catch (error) {
            console.error('Erro ao carregar script do WebComponent "mapa-geo-car-wc"...', error);
        }
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.checaCombinacaoTeclas);
    },
    created() {
        BUS.$on('loading:show', () => {
            this.loading = true;
        });
        BUS.$on('loading:hide', () => {
            this.loading = false;
        });
    },
};
</script>

<style>
:root {

    --primary: #3AAA1B;
    --primary-100: #E6FAD0;

    --primary-gray: rgb(238 238 238);
    --primary-white: whitesmoke;
    --primary-green: rgb(65 183 57);
    --primary-light-green: rgba(65, 183, 57, 0.292);
    --primary-smoke: rgb(255 255 255 / 51%);
    --primary-red: red;
    --primary-light-red: rgb(228, 97, 79);
    --primary-disable-red: rgb(228 97 79 / 33%);
    --primary-light-smoke: rgb(118 118 118);
    --primary-dark-smoke: rgb(116 113 113 / 43%);
    --primar-disable-gray: rgb(232 229 229);
    --primary-black: hsla(0, 3%, 7%, 0.788);
    --primary-transparent: transparent;
    --secondary-green: rgba(53, 145, 56);
    --secondary-regular-green: #9BE571;
    --secondary-light-green: #E6FAD0;
    --secondary-red: #D63519;
    --secondary-regular-red: #F29971;
    --secondary-light-red: #FDE4D0;
}

.main,
body {
    background-color: var(--primary-gray) !important;
}

#app {
    font-family: Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.page-content {
    height: 75vh;
}

.loading {
    position: relative;
}

.loading:after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--primary-smoke);
    background-image: url('./assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
    content: '';
    z-index: 1000;
}
</style>
